module.exports = __webpack_public_path__ + "static/media/roundaboutCCW135.82b6f151.svg";